import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {ExitButton} from '../styled-components/components'
import {switchScreen} from '../actions'
const AboutPage = styled.div`
position:absolute;
width:100vw;
height:100vh;
top:0;
left:0;
background:rgba(0,0,0,.9);
z-index:10;
text-align:center;`

const AboutPageContent = styled.div`
max-width:800px;
margin:0 auto;
position:relative;
`
const About = ({shouldShow, dispatch}) => {
    if(shouldShow) {
        return (
            <AboutPage>
                <AboutPageContent>
                    <h1>About DataLooper</h1>
                    <ExitButton onClick = {() => dispatch(switchScreen({screen : "default"}))}/>
                    <p>Big thank you to everyone who helped with this project. <br/>DataLooper is made with love and
                        intends to be the last MIDI foot controller you will ever have to buy.</p>

                    <h3>Special thanks to:</h3>

                    <p>Ron, Bonnie and Dan Cimo, Melinda Kincaid, Olly Twist, Griffin Davis, Shane Clary, Robert
                        Pessagno, Rory Aronson, Eric Mattson, Wesley Price, Dave Chesavage, Porongui, Vir McCoy</p>
                </AboutPageContent>
            </AboutPage>
        );
    } else{
        return null;
    }
}

function mapStateToProps(state){
    return {
        shouldShow : state.screen.screen === "about"
    }
}


export default connect(mapStateToProps)(About)